/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/field-utils";
import { BooleanFieldDisplay } from "./display";
import { BooleanFieldEdit } from "./edit";

const BooleanField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <BooleanFieldDisplay />,
        editComponent: <BooleanFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
BooleanField.displayName = "BooleanField";
export { BooleanField };
